import { createAction, props } from '@ngrx/store';
import { ContactInquiryRequest, ContactInquiryResponse, ContactInquiriesPage } from '../../models/contact.model';

export const submitContactInquiry = createAction(
  '[Contact] Submit Inquiry',
  props<{ data: ContactInquiryRequest }>()
);

export const submitContactInquirySuccess = createAction(
  '[Contact] Submit Inquiry Success',
  props<{ inquiry: ContactInquiryResponse }>()
);

export const submitContactInquiryFailure = createAction(
  '[Contact] Submit Inquiry Failure',
  props<{ error: string }>()
);

export const getContactInquiries = createAction(
  '[Contact] Get Inquiries',
  props<{ pageNumber?: number; pageSize?: number }>()
);

export const getContactInquiriesSuccess = createAction(
  '[Contact] Get Inquiries Success',
  props<{ page: ContactInquiriesPage }>()
);

export const getContactInquiriesFailure = createAction(
  '[Contact] Get Inquiries Failure',
  props<{ error: string }>()
);

export const getContactInquiryById = createAction(
  '[Contact] Get Inquiry By Id',
  props<{ id: number }>()
);

export const getContactInquiryByIdSuccess = createAction(
  '[Contact] Get Inquiry By Id Success',
  props<{ inquiry: ContactInquiryResponse }>()
);

export const getContactInquiryByIdFailure = createAction(
  '[Contact] Get Inquiry By Id Failure',
  props<{ error: string }>()
);

export const resetContactState = createAction('[Contact] Reset State');
